<script>
// import { Carousel, Slide } from 'vue-carousel';
import simplebar from "simplebar-vue";
import AnnouncementsApi from "@/services/announcements-api";

export default {
      components: {simplebar},
      props:{
        isSmall:{
          type: Boolean,
          default:false
        },
        isCatalogPage:{
          type: Boolean,
          default:false
        },
      },
      mounted(){
        this.getPromotionsAndNews()
      },
      data() {
        return {
          promotionsAndnewsList:[],
          showModal:false,
          selectedAnnouncment:{id:null,title:'',date:'',description:''},
          pagemodel: {currentPage : 1, perPage :this.isSmall ? 5   : 1, totalRows: 0},
          forceRenderSimpleBar: false,

          languages: ['frensh', 'english']
        }
      },
      methods:{
        getPromotionsAndNews(){
          AnnouncementsApi.getPromotionsAndNews(this.pagemodel.currentPage, this.pagemodel.perPage)
            .then(result => {


              if(result){
                if(!this.isSmall){
                  this.promotionsAndnewsList=result.list;
                }else{
                  for(const i in result.list){
                    this.promotionsAndnewsList.push(result.list[i])
                  }
                }
                
                this.pagemodel.totalRows = result.total;
                this.pagemodel.currentPage = result.page;
                this.pagemodel.perPage = result.pageSize;
                this.pagemodel.pageSize = result.pageSize;
                this.forceRenderSimpleBar=true;                
              }
            })
        },
        increaseCurrentPage(){
            if((this.pagemodel.totalRows-(this.pagemodel.currentPage+1))<(this.pagemodel.pageSize-1)){
                return
            }
            this.pagemodel.currentPage+=1
        },
        decreaseCurrentPage(){
            if(this.pagemodel.currentPage-1<=0){
                return
            }
            this.pagemodel.currentPage-=1
        },
      }
}
</script>
<template>
  <div>
    


    <div v-if="!isSmall" >
      <!-- <carousel :perPage="1"  paginationPosition="bottom-overlay" :loop="false" :rewind="false" :touchDrag="false" :paginationEnabled="false" :autoplay="false" :nav="false" :dots="false" :autoplayTimeout="4000"  paginationActiveColor="#fec235"  >
        <slide  v-for="(announcement) in this.promotionsAndnewsList" :key="announcement.id"> -->
          <div  v-for="(announcement) in this.promotionsAndnewsList" :key="announcement.id">
          

            <div v-if="!isCatalogPage" class="text-center  mb-4">
       


       <div class="row pb-4 pt-4" >
             <div class="col-12 text-left">
               <h2 class="text-dark font-weight-bold">
                 <div class="row ">
 
 
                     <div class="col-10 text-left text-primary">
 
                       Nos dernières Actualités
                     </div>
 
                     <div class="col-2 text-right">
 
                       <a href="javascript:void(0);" @click="decreaseCurrentPage();getPromotionsAndNews()" class="mr-2" :class="pagemodel.currentPage-1<=0 ?'text-secondary' : 'text-dark'">
                             <i class="fas fa-angle-left font-size-20" ></i>
                         </a>
 
                         <a href="javascript:void(0);" @click="increaseCurrentPage();getPromotionsAndNews()" :class="(pagemodel.totalRows-(pagemodel.currentPage+1))<(pagemodel.pageSize-1) ? 'text-light' : 'text-dark'">
                             <i class="fas fa-angle-right font-size-20" ></i>
                         </a>
                     </div>
 
                 </div>
               </h2>
               <!-- <h5 class="text-left font-weight-bold ">Nouveaux produits, services, ... </h5> -->
 
               <h3 class="text-truncate text-left font-weight-bold text-success blockTitle mt-4 mt-md-0 mt-lg-0 mt-xl-0 mt-sm-0">
                           <a href="javascript: void(0);" class="text-success" @click="showModal=true;selectedAnnouncment=announcement" >
                             {{$t('current_language')==languages[0]["frensh"] ? announcement.title : $t('current_language')==languages[0]["english"] ? announcement.titleEn : announcement.title}}
                           </a>
                         </h3>
 
             </div>
         </div>
 
 
     </div>



            <b-row no-gutters class="align-items-center pr-2">
            <b-col md="12" style="height:12em;">
                <b-card-img @click="showModal=true;selectedAnnouncment=announcement" :src="'/api/image/get/' + announcement.image" class="rounded-4 h-100 " style="border-radius: 5px;cursor:pointer"></b-card-img>
            </b-col>
            </b-row>
          
          
          <b-row no-gutters class="align-items-center pr-2">
            <!-- <b-col md="4" style="height:30em;">
                <b-card-img @click="showModal=true;selectedAnnouncment=announcement" :src="'/api/image/get/' + announcement.image" class="rounded-4 h-100 " style="border-radius: 5px;cursor:pointer"></b-card-img>
            </b-col> -->

            <b-col md="12" class="pl-2" >
                <div class=" h-100 w-100 d-none d-sm-block">
                  <div class=" mt-4 ">
                    <div class="media ">
                      <div class="media-body overflow-hidden">
                        <!-- <h5 class="text-truncate font-size-18 blockTitle mt-4 mt-md-0 mt-lg-0 mt-xl-0 mt-sm-0">
                          <a href="javascript: void(0);" class="text-primary" @click="showModal=true;selectedAnnouncment=announcement" >
                            {{$t('current_language')==languages[0]["frensh"] ? announcement.title : $t('current_language')==languages[0]["english"] ? announcement.titleEn : announcement.title}}
                          </a>
                        </h5> -->
                          <simplebar style="max-height: 14em; min-height:14em" class="mt-2"> 

                          <p  v-html="$t('current_language')==languages[0]['frensh'] ? announcement.description : $t('current_language')==languages[0]['english'] ? announcement.descriptionEn : announcement.description" 
                              class="text-justify text-secondary font-size-14 pt-0"> </p>
                        </simplebar>
                      </div>
                    </div>
                  </div>
                  <!-- <a href="javascript:void(0);" class="text-primary pl-4 pb-2" @click="showModal=true;selectedAnnouncment=announcement"
                      >{{$t('promotions.seeMore')}} <i class="mdi mdi-arrow-right"></i
                  ></a> -->
                  <div class="px-4 py-3 border-top">
                    <b-row>
                      <b-col md="6">
                        <i class="bx bx-calendar me-1"></i>
                          {{announcement.date}}
                      </b-col>
                      <b-col md="6" class="text-right">
                        <router-link tag="a" to="/" v-if="($t('current_language')==languages[0]['frensh'] && announcement.tag) || ($t('current_language')==languages[0]['english'] && announcement.tagEn) ">
                          <span 
                            :class="announcement.type==0 ? 'badge bg-danger text-white font-size-15' : 'badge bg-warning text-primary font-size-15'"
                            ><span > <strong>{{$t('current_language')==languages[0]["frensh"] ? announcement.tag : $t('current_language')==languages[0]["english"] ? announcement.tagEn : announcement.tag}}</strong> </span>
                              
                            </span
                          >
                        </router-link>
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <div class="d-sm-none d-lg-none d-md-none d-xl-none">
                    <h5 class="font-size-18 mt-4 mt-md-0 mt-lg-0 mt-xl-0 mt-sm-0">
                      <a href="javascript: void(0);" class="text-primary" @click="showModal=true;selectedAnnouncment=announcement" >
                        {{$t('current_language')==languages[0]["frensh"] ? announcement.title : $t('current_language')==languages[0]["english"] ? announcement.titleEn : announcement.title}}</a>
                    </h5>

                    <b-col>
                        <i class="bx bx-calendar me-1"></i>
                          {{announcement.date}}
                      </b-col>
                </div>
            </b-col>
          </b-row>
          </div>
        <!-- </slide>
      </carousel>  -->
      <span v-if=" !promotionsAndnewsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('promotions.empty')}} </span>
    </div>

    <simplebar v-if="isSmall && forceRenderSimpleBar" style="max-height: 12em; min-height:12em"> 
    <div class="table-responsive mb-0">
      <table class="table table-centered table-nowrap table-borderless mb-0">
        <tbody>
          <tr  v-for="(announcement) in this.promotionsAndnewsList" :key="announcement.id">
            <td style="width: 100px; cursor: pointer;">
              <img style="width:70px !important; height:70px !important" @click="showModal=true;selectedAnnouncment=announcement"
                :src="'/api/image/get/' + announcement.image"
                alt=""
                class="avatar-md h-auto d-block rounded"
              />
            </td>
            <td  class="pt-0">
              <h5 class="font-size-14 text-truncate mb-1">
                <a href="#" class="text-dark" @click="showModal=true;selectedAnnouncment=announcement"
                  >{{$t('current_language')==languages[0]["frensh"] ? announcement.title : $t('current_language')==languages[0]["english"] ? announcement.titleEn : announcement.title}}</a
                >
              </h5>
              <p class="text-muted mb-0">{{announcement.date}}</p>
            </td>
            
          </tr>

        </tbody>
      </table>
  <!-- <div class="row">
      <a v-if="promotionsAndnewsList.length<pagemodel.totalRows" href="javascript:void(0);" class="text-muted text-center col-12 mt-2" @click="increaseCurrentPage();getPromotionsAndNews()"
              ><span class="text-center">{{$t('promotions.seeMore')}} <i class="mdi mdi-arrow-down"></i
      ></span> </a>
  </div> -->
    </div>
    <span v-if="isSmall && !promotionsAndnewsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('promotions.empty')}} </span>
    </simplebar>  
    

    <b-modal
        v-model="showModal"
        v-if="selectedAnnouncment.id"
        :title="$t('current_language')==languages[0]['frensh'] ? selectedAnnouncment.title : $t('current_language')==languages[0]['english'] ? selectedAnnouncment.titleEn : selectedAnnouncment.title"
        hide-footer
        centered
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        size="xl">

          <b-row no-gutters class=" pr-2">
            <b-col md="3" >
                <b-card-img :src="'/api/image/get/' + selectedAnnouncment.image" class="rounded-4 h-100 " style="border-radius: 5px;"></b-card-img>
            </b-col>

            <b-col md="9" class="pl-0 pl-sm-2 mt-4 mt-md-0 mt-lg-0 mt-xl-0 mt-sm-0" >
                <div class="card h-100 w-100 ">
                  <div class="card-body pt-0">
                    <div class="media">
                      <div class="media-body overflow-hidden">

                        <span  v-html="$t('current_language')==languages[0]['frensh'] ? selectedAnnouncment.description : $t('current_language')==languages[0]['english'] ? selectedAnnouncment.descriptionEn : selectedAnnouncment.description"   class="text-justify "> </span>

                      </div>
                    </div>
                  </div>
                  <div class="px-4 py-3 border-top">
                    <b-row>
                      <b-col xs="6">
                        <i class="bx bx-calendar me-1"></i>
                          {{selectedAnnouncment.date}}
                      </b-col>
                      <b-col xs="6" class="text-right d-none d-sm-block">
                        <router-link tag="a" to="/" v-if="($t('current_language')==languages[0]['frensh'] && selectedAnnouncment.tag) || ($t('current_language')==languages[0]['english'] && selectedAnnouncment.tagEn) ">
                          <span 
                            :class="selectedAnnouncment.type==0 ? 'badge bg-danger text-white font-size-15' : 'badge bg-warning text-primary font-size-15'"
                            ><span > <strong>{{$t('current_language')==languages[0]["frensh"] ? selectedAnnouncment.tag : $t('current_language')==languages[0]["english"] ? selectedAnnouncment.tagEn : selectedAnnouncment.tag}}</strong> </span>
                              
                            </span
                          >
                        </router-link>
                      </b-col>
                    </b-row>
                  </div>
                </div>
            </b-col>
          </b-row>

    </b-modal>
</div>
</template>